import { Group, Modal, Stack, Title } from '@mantine/core';

import { useTranslation } from 'react-i18next';

import { Button } from '../../../../../../../../shared/components/UI/Button/Button';
import { TextArea } from '../../../../../../../../shared/components/UI/TextArea/TextArea';
import { TextInput } from '../../../../../../../../shared/components/UI/TextInput/TextInput';

import { useResponseProjectDetailContext } from '../../context/responseProjectDetailContext';
import { useResponseProjectCreateBlockFrom } from './hooks/useResponseProjectCreateBlockFrom.hooks';

interface ResponseProjectCreateBlockProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data?: {
    parentId?: number;
    index: number;
  };
}

export function ResponseProjectCreateBlock(
  props: ResponseProjectCreateBlockProps,
) {
  if (props.data && props.isOpen) {
    return <SafeResponseProjectCreateBlock {...props} />;
  }
  return null;
}

function SafeResponseProjectCreateBlock({
  isOpen,
  onClose,
  data,
}: ResponseProjectCreateBlockProps) {
  const { t } = useTranslation('bidResponse');
  const { projectId } = useResponseProjectDetailContext();

  const { form, handleSubmit } = useResponseProjectCreateBlockFrom({
    index: data?.index ?? 1,
    parentId: data?.parentId,
    projectId,
    onSuccess: onClose,
  });

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      withCloseButton={false}
      radius="md"
      centered={true}
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack p="05" spacing="00">
          <Title order={5} pb="05">
            {t('projectDetail.createBlock.title')}
          </Title>
          <Stack spacing="04">
            <TextInput
              label={t('projectDetail.createBlock.nameField.label')}
              required
              placeholder={t('projectDetail.createBlock.nameField.placeholder')}
              {...form.getInputProps('title')}
            />
            <TextArea
              label={t('projectDetail.createBlock.descriptionField.label')}
              placeholder={t(
                'projectDetail.createBlock.descriptionField.placeholder',
              )}
              {...form.getInputProps('description')}
            />
          </Stack>
          <Group position="right" mt="04">
            <Button variant="subtle" onClick={onClose}>
              {t('projectDetail.createBlock.cancelButton')}
            </Button>
            <Button size="md" type="submit">
              {t('projectDetail.createBlock.submitButton')}
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
